import { runInAction } from 'mobx';
import { RBACRunbookPermission } from '@kentik/ui-shared/rbac/constants';
import $auth from 'app/stores/$auth';
import { Collection } from 'core/model';
import RunbookModel from 'app/views/core/runbooks/RunbookModel';

const KENTIK_RUNBOOKS_GROUP = 'Kentik Runbooks';
const ORGANIZATION_RUNBOOKS_GROUP = 'Organization Runbooks';

class RunbookCollection extends Collection {
  get model() {
    return RunbookModel;
  }

  get url() {
    return '/api/ui/runbook';
  }

  get defaultGroupBy() {
    const hasMultipleGroups = this.unfiltered.some((m) => m.isPreset) && this.unfiltered.some((m) => !m.isPreset);
    if (hasMultipleGroups) {
      return { groupByFn: (model) => (model.isPreset ? [KENTIK_RUNBOOKS_GROUP] : [ORGANIZATION_RUNBOOKS_GROUP]) };
    }
    return null;
  }

  get sortedGroupKeys() {
    if (!this.groupBy) {
      return [];
    }

    const groupedModels = this.groupedData;
    const keys = Object.keys(groupedModels);

    return keys.sort((a, b) => {
      if (a === KENTIK_RUNBOOKS_GROUP) {
        return 1;
      }
      if (b === KENTIK_RUNBOOKS_GROUP) {
        return -1;
      }
      return a.localeCompare(b);
    });
  }

  get defaultSortState() {
    return {
      field: 'name',
      direction: 'desc'
    };
  }

  fetch(options = {}) {
    if (!$auth.hasRbacPermissions([RBACRunbookPermission.READ])) {
      return Promise.resolve(null);
    }

    return super.fetch(options).then((result) => {
      runInAction(() => {
        this.groupBy = this.defaultGroupBy;
      });
      return result;
    });
  }

  getRunbooksForResource(resourceType, resourceId) {
    if (!resourceType || !resourceId) {
      return [];
    }

    return this.get().filter((runbook) => {
      const mappings = runbook.getMappingsOfType(resourceType);
      return mappings.some(({ resource_id }) => resource_id === String(resourceId));
    });
  }
}

export default RunbookCollection;
